var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTalkToExpert = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.1833C17.5 5.60833 13.95 2.5 10 2.5C6.09167 2.5 2.5 5.54167 2.5 10.2333C2.00001 10.5167 1.66667 11.05 1.66667 11.6667V13.3333C1.66667 14.25 2.41667 15 3.33334 15C3.79167 15 4.16667 14.625 4.16667 14.1667V10.1583C4.16667 6.96667 6.625 4.175 9.81667 4.08333C13.1167 3.98333 15.8333 6.63333 15.8333 9.91667V15.8333H10C9.54167 15.8333 9.16667 16.2083 9.16667 16.6667C9.16667 17.125 9.54167 17.5 10 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V14.8167C17.9917 14.5583 18.3333 14.05 18.3333 13.45V11.5333C18.3333 10.95 17.9917 10.4417 17.5 10.1833Z",
    fill: "#4A3AB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50001 11.6667C7.96024 11.6667 8.33334 11.2936 8.33334 10.8333C8.33334 10.3731 7.96024 10 7.50001 10C7.03977 10 6.66667 10.3731 6.66667 10.8333C6.66667 11.2936 7.03977 11.6667 7.50001 11.6667Z",
    fill: "#4A3AB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.6667C12.9602 11.6667 13.3333 11.2936 13.3333 10.8333C13.3333 10.3731 12.9602 10 12.5 10C12.0398 10 11.6667 10.3731 11.6667 10.8333C11.6667 11.2936 12.0398 11.6667 12.5 11.6667Z",
    fill: "#4A3AB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9.19167C14.6 6.81667 12.5333 5 10.0417 5C7.51667 5 4.8 7.09167 5.01667 10.375C7.075 9.53333 8.625 7.7 9.06667 5.46667C10.1583 7.65833 12.4 9.16667 15 9.19167Z",
    fill: "#4A3AB1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTalkToExpert, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/talk_to_expert.14ec70b4.svg";
export { ForwardRef as ReactComponent };